import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GENERATE_MEMBERSHIPS, GENERATE_MEMBERSHIPS_ERROR, GENERATE_MEMBERSHIPS_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* generateMemberships({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/memberships/generate?${payload?.params?.id}`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GENERATE_MEMBERSHIPS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GENERATE_MEMBERSHIPS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GENERATE_MEMBERSHIPS_ERROR, payload: error });
  }
}

export function* watchGenerateMemberships() {
  yield takeEvery(GENERATE_MEMBERSHIPS, generateMemberships);
}

function* generateMembershipsSaga() {
  yield all([fork(watchGenerateMemberships)]);
}

export default generateMembershipsSaga;
